/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  SWITCH_LOCALE,
  SET_USER_LOCALE,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const switchLocaleAction = createAction(SWITCH_LOCALE)
const setUserLocaleAction = createAction(SET_USER_LOCALE)

/**
 * Export
 */
export const switchLocale = (params) => async (dispatch) => {
  try {
    dispatch(switchLocaleAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
export const setUserLocale = (params) => async (dispatch) => {
  try {
    dispatch(setUserLocaleAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/intl.js